import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
    faFacebookF,
    faTwitter,
    faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import{ faMobile, faEnvelope } from "@fortawesome/free-solid-svg-icons";

export default {
    name: 'Contact',
    components: {
        FontAwesomeIcon
    },
    data() {
        return {
            twitter: faTwitter,
            facebook: faFacebookF,
            instagram: faInstagram,
            mail: faEnvelope,
            mobile: faMobile,
            name: null,
            email: null,
            phone: null,
            message: null,
        }
    },
    methods: {
    }

}